import videojs from 'video.js';

const Component = videojs.getComponent('Component');

/**
 * TODO: Major refactoring needed here. This is ripped straight from the
 * videojs-hls-quality-selector plugin for convenience.
 */
export default class HLSQualitySelector extends Component {
  constructor(player, options) {
    super(player, options);

    this.player = player;

    // If there is quality levels plugin and the HLS tech exists
    // then continue.
    if (this.player.qualityLevels && this.getHls()) {
      // Create the quality button.
      this.createQualityButton();
      this.bindPlayerEvents();
    }
  }

  getHls() {
    return this.player.tech(true).hls;
  }

  bindPlayerEvents() {
    this.player.qualityLevels().on('addqualitylevel', this.onAddQualityLevel.bind(this));
  }

  createQualityButton() {
    const { player } = this;
    const videoJsButtonClass = videojs.getComponent('MenuButton');
    const ConcreteButtonClass = videojs.extend(videoJsButtonClass, {
      constructor() {
        videoJsButtonClass.call(this, player, { title: player.localize('Quality') });
      },
      createItems() {
        return [];
      },
    });

    this._qualityButton = new ConcreteButtonClass();

    const placementIndex = player.controlBar.children().length - 2;
    const concreteButtonInstance = player.controlBar.addChild(
      this._qualityButton,
      { componentClass: 'qualitySelector' },
      placementIndex,
    );
    concreteButtonInstance.addClass('vjs-quality-selector');
    concreteButtonInstance.removeClass('vjs-hidden');

    // make sure this gets added to the child element so styling doesn't break
    concreteButtonInstance.menuButton_.addClass('vjs-icon-cog');
  }

  getQualityMenuItem(item) {
    const self = this;
    const { player } = this;
    const videoJsMenuItemClass = videojs.getComponent('MenuItem');
    const ConcreteMenuItemClass = videojs.extend(videoJsMenuItemClass, {
      constructor() {
        videoJsMenuItemClass.call(this, player, {
          label: item.label,
          selectable: true,
          selected: item.selected || false,
        });
      },

      handleClick() {
        // Reset other menu items selected status.
        for (let i = 0; i < self._qualityButton.items.length; ++i) {
          self._qualityButton.items[i].selected(false);
        }

        // Set this menu item to selected, and set quality.
        self.setQuality(item.value);
        this.selected(true);
      },
    });
    return new ConcreteMenuItemClass();
  }

  onAddQualityLevel() {
    const { player } = this;
    const qualityList = player.qualityLevels();
    const levels = qualityList.levels_ || [];
    const levelItems = [];

    for (let i = 0; i < levels.length; ++i) {
      const levelItem = this.getQualityMenuItem.call(this, {
        label: `${levels[i].height}p`,
        value: levels[i].height,
      });
      levelItems.unshift(levelItem);
    }

    levelItems.push(
      this.getQualityMenuItem.call(this, {
        label: 'Auto',
        value: 'auto',
        selected: true,
      }),
    );

    if (this._qualityButton) {
      this._qualityButton.createItems = () => levelItems;
      this._qualityButton.update();
    }
  }

  setQuality(height) {
    const qualityList = this.player.qualityLevels();
    for (let i = 0; i < qualityList.length; ++i) {
      const quality = qualityList[i];
      quality.enabled = quality.height === height || height === 'auto';
    }
    this._qualityButton.unpressButton();
  }
}



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/quality/HLSQualitySelector.js